import { useState } from "react";
import Layout from "../../../Components/Layout";
import Promocodes from "../../../Components/Promocode/Promocodes";
import { useSelector } from "react-redux";
const MyEventsPage = () => {
  const [addPromocodeModel, setAddPromoCodeModel] = useState(false);
  const { userDetails } = useSelector((state) => state.user);
  const changeAddModalState = () => {
    setAddPromoCodeModel(!addPromocodeModel);
  };

  return (
    <Layout
      ExtraclassName="event-promo-code-panel"
      activeMenuId="promo-code"
      Heading="Promocode"
      TitleMark={true}
      TitleMarkClassName="event-promo-code-title-mark"
      TitleClassName="event-promo-code-title"
      HeadClassName="event-promo-code-head"
      extraElement={
        userDetails.userType === "organizer" ? (
          <button
            type="button"
            className="event-promo-code-add-btn"
            onClick={changeAddModalState}
          >
            Add Promo Code
          </button>
        ) : null
      }
    >
      <Promocodes
        addPromocodeModel={addPromocodeModel}
        closeAddModel={changeAddModalState}
      />
    </Layout>
  );
};
export default MyEventsPage;
